export default __webpack_public_path__ + "static/media/scroll.2c24f2a0.svg";